import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'

const MiddleTruncate = ({ children, maxLength, ...otherProps }) => {
  const { className, ...otherPropsSansClassName } = otherProps
  const classNames = ['w-middle-truncate'].concat(className ? [className] : []).join(' ')
  const text = children || ''
  const length = text.length
  if (length <= maxLength) {
    return <span className={classNames} {...otherPropsSansClassName} fulltext={text}>{text}</span>
  }
  const remainingLength = maxLength - 3
  const leftLength = Math.ceil(remainingLength / 2)
  const rightLength = remainingLength - leftLength
  const truncatedText =
    R.take(leftLength, text) +
    '...' +
    R.drop(length - rightLength, text)
  return <span className={classNames} {...otherPropsSansClassName} fulltext={text}>{truncatedText}</span>
}

MiddleTruncate.propTypes = {
  children: PropTypes.string,
  maxLength: PropTypes.number
}

export default MiddleTruncate
